// extracted by mini-css-extract-plugin
module.exports = {"link":"_6444e049b8--link--TJWct","image":"_6444e049b8--image--UMo3b","content":"_6444e049b8--content--t57wv"};